<template>
  <v-btn
    class="btn"
    large="large"
    :block="block"
    flat="flat"
    :disabled="disabled"
    :type="type"
    :loading="loading"
    @click.native="onClick($event)"
  >
    <v-icon class="grey--text btn--text pr-2">
      {{ icon }}
    </v-icon><span
      class="btn--text"
      :class="colorText"
    >{{ text }}</span>
  </v-btn>
</template>

<script>
import BtnTemplate from './BtnTemplate.vue';

export default {
  name: 'BtnFlat',
  extends: BtnTemplate,
  props: {
    icon: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    colorText() {
      return `${this.color}--text`;
    },
  },
};
</script>
